import { connect } from "react-redux";
import { Dispatch } from "redux";
import { employeesSelector } from "../../../../store/employees.store";
import { RootState } from "../../../../store/index.store";
import { Assign } from "../../../../types/types";
import { assignPageSelectors } from "../../assign-page.selector";
import { assignPageActions, GridState } from "../../assign-page.store";
import { AssignList } from "./AssignList";

const mapStateToProps = (state: RootState) => ({
  nenkiInfo: assignPageSelectors.getNenkiInfo(state),
  assigns: assignPageSelectors.getFilteredAssigns(state),
  employees: employeesSelector(state),
  groupingKey: assignPageSelectors.getSelectedGroupingCondition(state),
  defaultGroupingExpansionState: assignPageSelectors.getDefaultGroupingExpansionState(
    state
  ),
  selectedItem: assignPageSelectors.getSelectedAssign(state),
  gridState: assignPageSelectors.getGridState(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  edit: (assigns: Assign[]) =>
    dispatch(assignPageActions.USER_EDIT_ASSIGN({ assigns })),
  changeOrder: (order: number[]) =>
    dispatch(
      assignPageActions.SYSTEM_UPDATE_ASSIGN_ORDER({ assignOrder: order })
    ),
  changeGridState: (gridState: GridState) =>
    dispatch(assignPageActions.USER_CHANGE_GRID_STATE({ gridState })),
  changeCurrentRow: (id?: number, rowIndex?: number) =>
    dispatch(assignPageActions.USER_SELECT_ASSIGN({ id, rowIndex }))
});

export const AssignListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignList);
